import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthenticationService } from '../services/authentication.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Urls } from 'src/app/models/urls';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    public showChangePasswordMessage = false;
    private delay = ms => new Promise(res => setTimeout(res, ms));

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly oAuthService: OAuthService,
        private readonly authenticationService: AuthenticationService
    ) {}

    async ngOnInit(): Promise<void> {
        if (this.route.snapshot.queryParamMap.get('changePasswordSucceeded') === 'true') {
            // jwt interceptor required currentUser object, could not call send email api without login user first
            if (await this.authenticationService.loginWithTokens()) {
                this.showChangePasswordMessage = true;
            }
        }

        if (this.route.snapshot.queryParamMap.get('forceLogout') === 'true') {
            if (this.showChangePasswordMessage) {
                await this.delay(5000);
            }
            this.authenticationService.doLogout(true);
        }

        // redirected from Auth0 for some errors
        if (this.route.snapshot.queryParamMap.get('success') === 'false') {
            const message = this.route.snapshot.queryParamMap.get('message');
            await this.openErrorPage(message);
            return;
        }

        const currentUser = this.authenticationService.getCurrentUser();
        if (currentUser) {
            // authorised so return true
            await this.openWorklist();
            return;
        }

        // check if token exists in browser storage.
        if (await this.authenticationService.loginWithTokens()) {
            await this.openWorklist();
            return;
        }

        // By default, initiate Auth0 login process.
        const params = {} as Params;
        if (this.route.snapshot.queryParamMap.get('showForgotPassword') === 'true') {
            params.showForgotPassword = true;
        }
        if (this.route.snapshot.queryParamMap.get('userSkippedPasswordChange') === 'true') {
            params.skipAutomaticPasswordChange = true;
        }
        this.oAuthService.initCodeFlow(null, params);
    }

    async openWorklist(): Promise<void> {
        await this.router.navigate([Urls.WORKLIST]);
    }

    async openErrorPage(message: string): Promise<void> {
        const errorParams = { message } as Params;
        await this.router.navigate(['/error'], { queryParams: errorParams });
    }
}
